import React, { useEffect } from "react";
import lottie from 'lottie-web';
import animationData from "../animation-data/parent-area/data.json";

function StatisticsAnimationMobile() {
  useEffect(() => {
    lottie.loadAnimation({
      container: document.getElementById('parent-area-animation'),
      renderer: 'svg',
      loop: false,
      autoplay: true,
      animationData: animationData,
      progressiveLoad: true,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    });
  },[])

  return (
    <div id="parent-area-animation"></div>
  )
}

export default StatisticsAnimationMobile;